import {
  Button,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  Paper,
  Chip,
} from "@mui/material";
import React, { useState } from "react";
import {
  addStockIntakeItem,
  getImportItemById,
} from "../../../services/Import";
import CloseIcon from "@mui/icons-material/Close";
import Validation from "../../../Validation/Im_StockIntakeValidation";
import { makeStyles } from "@mui/styles";
import InputField from "../../../FormComponents/InputField";
import ItemSelectingPopup from "../../../components/ItemSelectingPopup";
import SyncIcon from "@mui/icons-material/Sync";
import FormAlert from "../../../components/FormAlert";

const useStyles = makeStyles({
  categoryContainer: {
    padding: "10px",
  },
  categoryTag: {
    marginRight: "10px",
  },
});

function Im_stockUpdateForm({ setOpenForm }) {
  const classes = useStyles();

  //for input feild values
  const [value, setValue] = useState({
    _importitem: null,
    _importQty: 0,
    _pricePerItem: 0.0,
    _totalPrice: 0.0,
    _discount: 0.0,
    _billUnit: "",
    _itemUintsPerBillUnit: 0.0,
    _note: "",
  });

  //Reset values
  const resetValues = () => {
    setValue({
      _importitem: null,
      _importQty: 0,
      _pricePerItem: 0.0,
      _totalPrice: 0.0,
      _discount: 0.0,
      _billUnit: "",
      _itemUintsPerBillUnit: 0.0,
      _note: "",
    });
    setSelectedItem([]);
    setSelectedItemData(null);
  };

  // set open category table
  const [openItemTable, setOpenItemTable] = useState(false);
  const [selectedItem, setSelectedItem] = useState([]);
  const [selectedItemData, setSelectedItemData] = useState(null);
  const [rows, setRows] = React.useState([]);

  const handleOpenItemTable = async () => {
    setOpenItemTable(true);
  };

  const handleCloseItemTable = async () => {
    const itemDataResponse = await getImportItemById(selectedItem[0]);
    if (itemDataResponse != "Something went wrong...") {
      setSelectedItemData(itemDataResponse);
      setOpenItemTable(false);
      handleChange("_importitem", itemDataResponse);
    } else {
      setError({
        ...error,
        _importItem: "Canot fetch Item...",
      });
      setOpenItemTable(false);
    }
  };

  // errors for inputfeild
  const [error, setError] = useState({
    _importItem: "",
    _price: "",
    _importQty: "",
  });

  //display alert...
  const [displayAlert, setAlert] = useState(false);

  //alert data
  const [alertData, setAlertData] = useState({
    type: "",
    message: "",
  });

  const closeAlert = () => {
    setAlert(false);
    setAlertData({
      type: "",
      message: "",
    });
  };

  //reset errors...
  const resetErrors = () => {
    setError({});
  };

  //set error
  const submitValue = async () => {
    const validationErrors = Validation(value);
    setError(validationErrors);
    if (!validationErrors._importItem && !validationErrors._price && !validationErrors._importQty) {
      let data = { ...value };
      let submitStockUpdate = await addStockIntakeItem(data);
      if (submitStockUpdate) {
        resetValues();
        setAlertData({
          type: "success",
          message: "Item submitted..",
        });
        setAlert(true);
        setError({});
      } else {
        setAlertData({
          type: "error",
          message: "Something went wrong...",
        });
        setAlert(true);
      }
    }
  };

  //to handle changing value
  const handleChange = (name, val) => {
    setValue({
      ...value,
      [name]: val,
    });
  };

  //import item price and discount operations
  // Relationship: totalPrice = (pricePerItem * qty) - discount
  // Reverse:      pricePerItem = (totalPrice + discount) / qty
  const priceDiscountOperations = () => {
    const pricePerItem = parseFloat(value._pricePerItem) || 0;
    const totalPrice = parseFloat(value._totalPrice) || 0;
    const discount = parseFloat(value._discount) || 0;
    const importQty = parseFloat(value._importQty) || 0;

    if (importQty <= 0) return;

    if (pricePerItem > 0 && totalPrice === 0.0) {
      // Calculate total from unit price: total = (unitPrice * qty) - discount
      const calculatedTotal = parseFloat(
        (pricePerItem * importQty - discount).toFixed(2)
      );
      setValue({ ...value, _totalPrice: Math.max(0, calculatedTotal) });
    } else if (pricePerItem === 0.0 && totalPrice > 0.0) {
      // Calculate unit price from total: unitPrice = (total + discount) / qty
      const calculatedUnitPrice = parseFloat(
        ((totalPrice + discount) / importQty).toFixed(2)
      );
      setValue({ ...value, _pricePerItem: calculatedUnitPrice });
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={11} sx={12}>
        <Typography mt={1} variant="h6">
          {" "}
          Add Stock Intake{" "}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={1} sx={12}>
        <Tooltip title="Close">
          <IconButton
            onClick={() => {
              setOpenForm(false);
            }}
            aria-label="close"
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Grid>
      {selectedItemData ? (
        <>
          <Grid item xs={12} sm={3} sx={12}>
            <InputField
              isdisabled={true}
              name="_itemName"
              value={selectedItemData.itemName}
              type="text"
              label="Item"
            />
          </Grid>
          <Grid item xs={12} sm={3} sx={12}>
            <InputField
              isdisabled={true}
              name="_productCode"
              value={selectedItemData.product_code}
              type="text"
              label="Item Code"
            />
          </Grid>
          <Grid item xs={12} sm={3} sx={12}>
            <InputField
              isdisabled={true}
              name="_unitType"
              value={selectedItemData.unitType}
              type="text"
              label="Unit Type"
            />
          </Grid>
          <Grid item xs={12} sm={12} sx={12}>
            <Paper className={classes.categoryContainer}>
              <Typography>Category</Typography>
              <Grid container spacing={1}>
                {selectedItemData.im_categories.map((category) => {
                  return (
                    <Grid item sx={2}>
                      <Chip
                        label={
                          <Typography>
                            <span
                              style={{ fontSize: "0.8rem", fontWeight: "500" }}
                            >
                              {Object.entries(category)
                                .filter(([key]) => key !== "cat_id") // Exclude `cat_id`
                                .map(([, value]) => value) // Extract only the values
                                .filter(Boolean) // Remove null or undefined values
                                .join(" : ")}{" "}
                            </span>
                          </Typography>
                        }
                        variant="outlined"
                        pt
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </Paper>
          </Grid>
        </>
      ) : error._importItem != "" ? (
        <Grid container>
          <Typography
            align="left"
            variant="caption"
            style={{
              color: "red",
              fontSize: 16,
              fontWeight: "bold",
              paddingLeft: 40,
            }}
          >
            {error._importItem}
          </Typography>
        </Grid>
      ) : null}
      <Grid item xs={12} sm={9} sx={12}>
        <Button onClick={handleOpenItemTable} variant="outlined">
          Select Item
        </Button>
      </Grid>
      {error._price != "" ? (
        <Grid container>
          <Typography
            align="left"
            variant="caption"
            style={{
              color: "red",
              fontSize: 16,
              fontWeight: "bold",
              paddingLeft: 40,
            }}
          >
            {error._price}
          </Typography>
        </Grid>
      ) : null}
      <Grid item xs={12} sm={4} sx={12}>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <InputField
              name="_billUnit"
              value={value._billUnit}
              onChange={(event, newInputValue) =>
                handleChange(event, newInputValue)
              }
              type="text"
              label="Intake Unit"
            />
          </Grid>
          <Grid item>
            <InputField
              name="_itemUintsPerBillUnit"
              value={value._itemUintsPerBillUnit}
              onChange={(event, newInputValue) =>
                handleChange(event, newInputValue)
              }
              type="number"
              label="Item Units Per Bill Unit"
            />
          </Grid>
          <Grid item>
            <InputField
              name="_importQty"
              errorMsg={error._importQty}
              value={value._importQty}
              onChange={(event, newInputValue) =>
                handleChange(event, newInputValue)
              }
              type="number"
              label="Import Qty"
            />
          </Grid>
          <Grid item>
            <InputField
              name="_pricePerItem"
              value={value._pricePerItem}
              onChange={(event, newInputValue) =>
                handleChange(event, newInputValue)
              }
              type="number"
              label="Price Per Item"
            />
          </Grid>
          <Grid item>
            <InputField
              name="_discount"
              value={value._discount}
              onChange={(event, newInputValue) =>
                handleChange(event, newInputValue)
              }
              type="number"
              label="Discount"
            />
          </Grid>
          <Grid item>
            <Grid container justifyContent="space-between">
              <Grid item xs={12} sm={11} sx={12}>
                <InputField
                  name="_totalPrice"
                  value={value._totalPrice}
                  onChange={(event, newInputValue) =>
                    handleChange(event, newInputValue)
                  }
                  type="number"
                  label="Total Price"
                />
              </Grid>
              <Grid item xs={12} sm={1} sx={12}>
                <Tooltip title="Calculate">
                  <IconButton
                    onClick={priceDiscountOperations}
                    aria-label="calculate"
                    size="small"
                  >
                    <SyncIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <InputField
              name="_note"
              value={value._note}
              multiline={true}
              rows={4}
              onChange={(event, newInputValue) =>
                handleChange(event, newInputValue)
              }
              type="text"
              label="Note"
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} sx={12}>
        {displayAlert ? (
          <FormAlert type={alertData.type} message={alertData.message} />
        ) : null}
      </Grid>
      <Grid item xs={12} sm={12} sx={12}>
        <Grid container justifyContent="space-between">
          <Grid item xs={12} sm={4} sx={12}>
            <Button fullWidth variant="contained" onClick={submitValue}>
              Submit
            </Button>
          </Grid>
          <Grid item xs={12} sm={1} sx={12}>
            <Button onClick={resetValues} variant="outlined">
              Reset
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <Grid>
        {openItemTable ? (
          <ItemSelectingPopup
            isOneChoise={true}
            setOpenTable={setOpenItemTable}
            openTable={openItemTable}
            handleCloseTable={handleCloseItemTable}
            setSelectedItems={setSelectedItem}
            selectedItems={selectedItem}
            setRows={setRows}
            rows={rows}
          />
        ) : null}
      </Grid>
    </Grid>
  );
}

export default Im_stockUpdateForm;
